import { useEffect, useRef } from 'react';

// Keep reference to previous value (using generics to keep compatible with all types)
const usePrevious = <T extends {}>(value: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export { usePrevious };
